import React, { useEffect, useState } from 'react'
import { useDispatch } from "react-redux";
import { getPermission, createPermission } from "./../../../../../services/global_redux/globale_actions/Permission.action"
import $ from 'jquery';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    FormHelperText,
    Grid,
    Box,
} from '@mui/material';
function CreatePermissions() {
    const dispatch = useDispatch();
    const [permissionData, setPermissionData] = React.useState([])
    const [open, setOpen] = React.useState(false);
    const [formValues, setFormValues] = useState({
        module_id: '',
        module_name: '',
        section_id: '',
        section_name: ''
    });
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('alues:', formValues);
        createNewPermission(formValues);
        handleClose();
    };
    const fetchPermission = async () => {
        try {
            const response = await dispatch(getPermission());
            setPermissionData(response.data);
            console.log("permissions", response.data);
        } catch (err) {
            console.error("Failed to fetch states:", err);
        }
    };

    useEffect(() => {
        fetchPermission();
    }, [dispatch]);
    const createNewPermission = async (data) => {
        try {
            const response = await dispatch(createPermission(data));
            fetchPermission();
        } catch (err) {
            console.error("Failed to fetch states:", err);
        }

    };
    const handleSearchClick = (e) => {
        e.preventDefault();
        const value = $('#searchInput').val().toLowerCase();
        $('#dataTable tbody tr').each(function () {
            const rowText = $(this).text().toLowerCase();
            const isVisible = rowText.includes(value);
            $(this).toggle(isVisible);
        });
    };

    return (
        <div className='contaner-fluid container-fluid-color py-4'>
            <div className="col-md-12">
                <div className="card mx-3">
                    <div className="card-header card-header-color">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6 pt-2">
                                    <h6> Create Permissions</h6>
                                </div>
                                <div className="col-md-6">
                                    <a href="/dashboard" className='text-white'><i className="bi bi-x float-end cancel-icon"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body bg-light">
                        <div className="col-md-12 mb-3">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="row">
                                        <div className="col-md-6 ms-1 mt-2">
                                            <button
                                                className="btn btn-info text-white me-3"
                                                onClick={() => handleOpen()}
                                            >
                                                <b>Add Permissions</b>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="row">
                                        <div className="col-md-12 float-end">
                                            <form action="">
                                                <div className=" d-flex search-div float-end">
                                                    <input
                                                        type="text"
                                                        placeholder="Search..."
                                                        id="searchInput"
                                                    />
                                                    <button onClick={handleSearchClick} className='search-submit'><i className="bi bi-search"></i></button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="card-header p-0 pe-3 ps-1">
                                <div className="col-md-12">
                                    <div className="row justify-content-between">
                                        <div className="col-md-2">
                                            <p className='col-md-11 pt-1 client-2nd-header-size m-0'>Total Entries: {permissionData ? permissionData.length : 0}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="table-responsive table-max-height">
                                <table className="table table-bordered table-text-size " id='dataTable'>
                                    <thead >
                                        <tr className='table-header-color sticky-top'>
                                            <th>SL NO</th>
                                            <th>Section ID</th>
                                            <th>Section Name</th>
                                            <th>Module ID</th>
                                            <th>Module Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {permissionData ? (<>
                                            {permissionData.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{item.section_id}</td>
                                                    <td>{item.section_name}</td>
                                                    <td>{item.module_id}</td>
                                                    <td>{item.module_name}</td>
                                                </tr>
                                            ))}
                                        </>) : (
                                            <>
                                                <tr>DATA NOT FOUND</tr>
                                            </>)

                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog open={open} onClose={handleClose} maxWidth="xl">
                <DialogTitle className="custom-dialog-title">Create Role</DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 0 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth variant="standard">
                                    <InputLabel htmlFor="section_id" className="custom-input-label">
                                        Section ID <span className="text-danger">*</span>
                                    </InputLabel>
                                    <TextField
                                        placeholder='Section Id'
                                        className="custom-text-field  mt-4 pt-3"
                                        id="section_id"
                                        name="section_id"
                                        required
                                        variant="standard"
                                        value={formValues.section_id}
                                        onChange={handleChange}
                                    />
                                    <FormHelperText id="user_code_result" className="text-danger"></FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth variant="standard">
                                    <InputLabel htmlFor="section_name" className="custom-input-label">
                                        Section Name <span className="text-danger">*</span>
                                    </InputLabel>
                                    <TextField
                                        placeholder='Section Name'
                                        className="custom-text-field  mt-4 pt-3"
                                        id="section_name"
                                        name="section_name"
                                        required
                                        variant="standard"
                                        value={formValues.section_name}
                                        onChange={handleChange}
                                    />
                                    <FormHelperText id="user_code_result" className="text-danger"></FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth variant="standard">
                                    <InputLabel htmlFor="module_id" className="custom-input-label">
                                        Module ID <span className="text-danger">*</span>
                                    </InputLabel>
                                    <TextField
                                        placeholder='Module Id'
                                        className="custom-text-field  mt-4 pt-3"
                                        id="module_id"
                                        name="module_id"
                                        required
                                        variant="standard"
                                        value={formValues.module_id}
                                        onChange={handleChange}
                                    />
                                    <FormHelperText id="user_code_result" className="text-danger"></FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FormControl fullWidth variant="standard">
                                    <InputLabel htmlFor="module_name" className="custom-input-label">
                                        Module Name <span className="text-danger">*</span>
                                    </InputLabel>
                                    <TextField
                                        placeholder='Module Name'
                                        className="custom-text-field  mt-4 pt-3"
                                        id="module_name"
                                        name="module_name"
                                        required
                                        variant="standard"
                                        value={formValues.module_name}
                                        onChange={handleChange}
                                    />
                                    <FormHelperText id="user_code_result" className="text-danger"></FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12} sx={{ textAlign: 'right' }}>
                                <Button type="submit" variant="contained" color="success" onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button onClick={handleClose} variant="contained" color="info" sx={{ ml: 2 }}>
                                    Cancel
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    )
}


export default CreatePermissions

